import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TripEditContextState } from './reducers-trip-edit';

export const selectTripEditContextState = createFeatureSelector<TripEditContextState>('tripEditContext');

export const selectTripEditData = createSelector(
  selectTripEditContextState,
  (state) => state.tripData
);

export const selectTripEditContext = createSelector(
  selectTripEditContextState,
  (state) => state
);